// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY;
// console.log(`SUPABASE_URL=${SUPABASE_URL}`)
// console.log(`SUPABASE_ANON_KEY=${SUPABASE_ANON_KEY}`)

// npx supabase gen types typescript --project-id ltlsrlqneeaywigzvzri > database.types.ts
// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});